<template>
  <div
    class="stat-icon counter"
    :class="{ active: variable !== 0, condensed: condensed }"
    @click.left.prevent="change(1)"
    @click.right.prevent="change(-1)"
  >
    <div class="icon-wrapper">
      <Icon :name="icon" class="size-2x" />
    </div>
    <div class="name">{{ name }}</div>
    <div class="value">
      {{ value }}<span v-if="unit" class="unit">{{ unit }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { clamp } from '../util'

const props = defineProps<{
  name: string
  maximum?: number
  unit?: string
  condensed?: boolean
}>()

const value = defineModel<number>({ default: 0 })

const variable = computed(() => value.value)

const icon = computed(() => {
  const icons: Record<number, string> = {
    0: `fa6-solid:square`,
    1: `fa6-solid:dice-one`,
    2: `fa6-solid:dice-two`,
    3: `fa6-solid:dice-three`,
    4: `fa6-solid:dice-four`,
    5: `fa6-solid:dice-five`,
    6: `fa6-solid:dice-six`,
  }
  return icons[value.value]
})

const change = (delta: number) => {
  value.value = clamp(value.value + delta, 0, props.maximum)
}
</script>

<style scoped lang="postcss">
.stat-icon.counter {
  cursor: pointer;
  justify-content: center;

  &.condensed {
    font-size: 0.8em;
  }

  &.active .icon {
    color: var(--text-highlight);
  }

  &:hover {
    background-color: var(--bg-primary);
  }
}
</style>
